export default function AgencementInterieur() {
  return (
    <main className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900">L'agencement intérieur</h1>
      <div className="mt-6 space-y-4 text-slate-700 leading-relaxed">
        <h3 className="font-semibold">Rez-de-chaussée</h3>
        <ul className="star-list">
          <li>Écran et panneaux d'information</li>
          <li>Vestiaire à chaussures pour les élèves</li>
          <li>Bureau administration et direction</li>
          <li>Espace adultes: salle d'équipe, repos, bureau éducateurs, WC, vestiaire</li>
          <li>Cuisine, salle polyvalente, logopédie, musicothérapie, ateliers de création</li>
          <li>WC filles et garçons, ascenseur</li>
        </ul>
        <h3 className="font-semibold">Étage</h3>
        <ul className="star-list">
          <li>Grand espace d'activités & expositions avec 2 ailes (bibliothèque, travail en petit groupe)</li>
          <li>5 salles de classe (7 à 8 élèves) avec alcôves cloisonnables</li>
          <li>Vestiaires et sanitaires</li>
        </ul>
        <h3 className="font-semibold">Sous-sol</h3>
        <ul className="star-list">
          <li>Locaux techniques, jeux, rangement et un grand local polyvalent</li>
        </ul>
      </div>
    </main>
  );
}
